import React from 'react';
import DeliveryWidget from './Deliveries/DeliveryWidget';

const CheckoutDeliveryMethods = ({
    getDeliveryConfig,
    zip,
    country,
    onChange,
    cart,
}) => (
    <section className="row delivery-container">
        <DeliveryWidget
            getDeliveryConfig={getDeliveryConfig}
            price={cart.grandTotal}
            orderRows={cart.orderRows}
            currency={cart.currency}
            zip={zip}
            country={country}
            onChange={onChange}
        />
    </section>
);

export default CheckoutDeliveryMethods;